// flow
import React, { PureComponent } from 'react';
import { HoshiInput, HoshiInputPropsType } from '../../../../components/common';
import I18n from '../../../../lib/i18n';

export default class HoshiInputWithCustomPlaceholder extends PureComponent<HoshiInputPropsType, void> {
  subInput: any;

  focus = () => {
    this.subInput.focus();
  };

  isEmpty = () => {
    return this.subInput.isEmpty();
  };

  render() {
    return (
      <HoshiInput
        ref={ref => (this.subInput = ref)}
        {...this.props}
        onChangeText={text => this.props.input && this.props.input.onChange && this.props.input.onChange(text)}
        onBlur={() => this.props.input && this.props.input.onBlur && this.props.input.onBlur(this.props.input.value)}
        placeholder={this.props.meta.active ? I18n.t('dateFormat') : I18n.t('birthdate')}
      />
    );
  }
}
